export interface ZendeskConversationField {
	id: string;
	value: string;
}

export const ZENDESK_FIELD_IDS = {
	userName: "49128817541147",
	permissions: "49128556758811",
	organizationId: "49128501829531",
	organizationName: "48757383658651",
	placeId: "49128731886619",
	placeName: "49128711570587",
	eventId: "49128623254939",
	eventName: "49128614519707",
	source: "49128446589979",
} as const;

const ZENDESK_KEY = "b5e17cb2-511a-4aa1-8c38-7324caa75204";

let loadPromise: Promise<void> | null = null;

let openIntent = false;

let authTokenRef: string | null = null;

let isLoginUserRegistered = false;

function registerLoginUser(zE: Function) {
	if (isLoginUserRegistered) return;
	zE("messenger", "loginUser", (callback: (token: string) => void) => {
		if (authTokenRef) callback(authTokenRef);
	});
	isLoginUserRegistered = true;
}

function getZE(): Function | undefined {
	return ((window as unknown) as Record<string, Function>).zE;
}

function loadZendeskScript(): Promise<void> {
	if (window.Zendesk) return Promise.resolve();
	if (loadPromise) return loadPromise;

	loadPromise = new Promise((resolve, reject) => {
		const settings = document.createElement("script");
		settings.textContent = `
			window.zESettings = {
				messenger: { launcher: { visible: false } }
			};
		`;
		document.head.appendChild(settings);

		const script = document.createElement("script");
		script.id = "ze-snippet";
		script.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`;
		script.defer = true;
		script.onload = () => {
			const zE = getZE()!;

			zE("messenger:set", "cookies", true);

			const style = document.createElement("style");
			style.textContent = `
				iframe#launcher,
				iframe[title*="launch" i] { display: none !important; }
			`;
			document.head.appendChild(style);

			window.Zendesk = {
				open: () => zE("messenger", "open"),
				close: () => zE("messenger", "close"),
				set: (field, value) => zE("messenger:set", field, value),
			};
			resolve();
		};
		script.onerror = () => {
			loadPromise = null;
			reject(new Error("Zendesk script failed to load"));
		};
		document.head.appendChild(script);
	});

	return loadPromise;
}

export function setZendeskAuthToken(jwt: string) {
	authTokenRef = jwt;
}

export function logoutZendesk() {
	if (!isLoginUserRegistered) return;
	authTokenRef = null;
	isLoginUserRegistered = false;
	const zE = getZE();
	if (zE) {
		zE("messenger", "logoutUser");
	}
}

export function setZendeskOpenIntent(value: boolean) {
	openIntent = value;
}

export async function openZendeskChat(fields?: ZendeskConversationField[]) {
	await loadZendeskScript();

	if (!openIntent) return;

	const zE = getZE();
	if (!zE) return;

	if (authTokenRef) registerLoginUser(zE);

	if (fields?.length) {
		zE("messenger:set", "conversationFields", fields);
	}
	zE("messenger", "open");
}

export function closeZendeskChat() {
	openIntent = false;
	const zE = getZE();
	if (zE) {
		zE("messenger", "close");
	}
}
